export default __webpack_public_path__ + "static/media/963_IMG2440.72912b26.jpg";